/**
 * Handle fixed element on scroll
 */

import { $window } from '../utils/globals.js'

const handleFixedElement = () => {
	const winH = $window.height();
	const $sectionTeam = $('.main');
	const $actions = $('.btn--fixed-wrapper');
	let scrollTopCurrent = 0;

	$window.on('load scroll resize', function () {
		scrollTopCurrent = $window.scrollTop() + $window.height();

		if ($sectionTeam.length) {
			const $sectionBottom = $sectionTeam.offset().top + $sectionTeam.height();

			if (scrollTopCurrent > $sectionBottom ) {
				$actions.addClass('is-bottom');
			} else {
				$actions.removeClass('is-bottom');
			}
		}
	});
}

handleFixedElement();
